import { h } from 'preact';
import * as BaseComp from 'components/pages/homeEnt/homeEnt.js';
import s from 'components/pages/homeEnt/homeEnt.sss';

export default class HomeEnt extends BaseComp.default {


	getExtraLinks() {
		if (this.props.pageData.iframeSrc) {
			return (
				<div class={s.iframeWrapper}>
					<iframe scrolling="no" src={this.props.pageData.iframeSrc} />
				</div>
			);
		} else {
			return '';
		}
	}



}

export const verticallyCenter = BaseComp.verticallyCenter;
export const dependencies = BaseComp.dependencies;
